import { IRectProps } from '.';
import styled, { keyframes } from 'styled-components';

const shimmerAnimation = keyframes`
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
`;

interface SkeletonBaseProps extends IRectProps {
  background: string;
  foreground: string;
}

export const SkeletonBase = styled.div<SkeletonBaseProps>`
  display: inline-block;
  height: ${(props) =>
    typeof props.height === 'string'
      ? props.height
      : props.height
        ? `${props.height}px`
        : '100%'};
  width: ${(props) =>
    typeof props.width === 'string'
      ? props.width
      : props.width
        ? `${props.width}px`
        : '100%'};
  border-radius: ${(props) => (props.rounded ? `24px` : `8px`)};
  background: ${(props) =>
    `linear-gradient(to right, ${props.background} 8%, ${props.foreground} 18%, ${props.background} 33%)`};
  background-size: 200% 100%;
  animation: ${shimmerAnimation} 3s infinite;
`;
